import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './CalendarOptions.scss';
var CalendarOptions = /*#__PURE__*/function (_Component) {
  function CalendarOptions(props) {
    var _this;
    _classCallCheck(this, CalendarOptions);
    _this = _callSuper(this, CalendarOptions, [props]);
    var startDate = moment(props.startDate);
    var endDate = moment(props.startDate).add(startDate.daysInMonth() - 1, 'days');
    var startingWeekday = Number(startDate.format('d'));
    var endingWeekday = Number(endDate.format('d'));
    var calendarEndDate = moment(endDate).add(6 - endingWeekday, 'days');
    var weeksArray = [[]];
    var date = moment(props.startDate).subtract(startingWeekday, 'days');
    while (date.isSameOrBefore(calendarEndDate, 'day')) {
      if (weeksArray[weeksArray.length - 1].length === 7) {
        weeksArray[weeksArray.length] = [];
      }
      weeksArray[weeksArray.length - 1] = weeksArray[weeksArray.length - 1].concat(moment(date));
      date.add(1, 'days');
    }
    _this.state = {
      monthLabel: startDate.format('MMMM YYYY'),
      weeksArray: weeksArray
    };
    _this.renderDay = _this.renderDay.bind(_this);
    _this.renderWeek = _this.renderWeek.bind(_this);
    return _this;
  }
  _inherits(CalendarOptions, _Component);
  return _createClass(CalendarOptions, [{
    key: "renderDay",
    value: function renderDay(day) {
      var _this$props = this.props,
        availableDays = _this$props.availableDays,
        selectedDate = _this$props.selectedDate,
        startDate = _this$props.startDate,
        updateSelection = _this$props.updateSelection,
        disabled = _this$props.disabled;
      var date = Number(day.format('D'));
      var inCurrentMonth = startDate.getMonth() === Number(day.month());
      var available = inCurrentMonth && (availableDays.includes(date) ? 'available' : '');
      var selected = inCurrentMonth && !disabled && selectedDate && selectedDate.getDate() === day.date() && selectedDate.getMonth() === day.month() ? 'selected' : '';
      var updateFunction = available && !disabled ? updateSelection : function () {};
      return /*#__PURE__*/React.createElement("td", {
        role: "gridcell",
        "data-date": day,
        className: "".concat(available, " ").concat(selected),
        onClick: updateFunction
      }, date);
    }
  }, {
    key: "renderWeek",
    value: function renderWeek(week) {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("tr", null, week.map(function (day) {
        return _this2.renderDay(day);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var disabled = this.props.disabled;
      var _this$state = this.state,
        monthLabel = _this$state.monthLabel,
        weeksArray = _this$state.weeksArray;
      return /*#__PURE__*/React.createElement("table", {
        className: "calendar-table ".concat(disabled ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        className: "month-label",
        colSpan: "7"
      }, monthLabel)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Su"), /*#__PURE__*/React.createElement("th", null, "Mo"), /*#__PURE__*/React.createElement("th", null, "Tu"), /*#__PURE__*/React.createElement("th", null, "We"), /*#__PURE__*/React.createElement("th", null, "Th"), /*#__PURE__*/React.createElement("th", null, "Fr"), /*#__PURE__*/React.createElement("th", null, "Sa"))), /*#__PURE__*/React.createElement("tbody", null, weeksArray.map(function (week) {
        return _this3.renderWeek(week);
      })));
    }
  }]);
}(Component);
CalendarOptions.propTypes = {
  startDate: PropTypes.shape({}).isRequired,
  availableDays: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedDate: PropTypes.shape({}),
  updateSelection: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
CalendarOptions.defaultProps = {
  selectedDate: new Date(),
  disabled: false
};
export default CalendarOptions;